var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30807_12325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.95 4.00313C16.2906 4.19063 16.5 4.54688 16.5 4.93438C16.5 5.525 16.025 6 15.4344 6H1.56438C0.976563 6 0.5 5.525 0.5 4.93438C0.5 4.54688 0.710781 4.19063 1.05031 4.00313L8.1375 0.0933141C8.3625 -0.0311047 8.6375 -0.0311047 8.8625 0.0933141L15.95 4.00313ZM7.5 4C7.5 3.44688 7.94688 3 8.5 3C9.05313 3 9.5 3.44688 9.5 4C9.5 4.18125 9.45 4.35313 9.36563 4.5H13.7437L8.5 1.60656L3.25563 4.5H7.63438C7.55 4.35313 7.5 4.18125 7.5 4ZM2.5 7H4V12H6V7H7.5V12H9.5V7H11V12H13V7H14.5V12H14.75C15.1656 12 15.5 12.3344 15.5 12.75C15.5 13.1656 15.1656 13.5 14.75 13.5H2.5C2.08594 13.5 1.75 13.1656 1.75 12.75C1.75 12.3344 2.08594 12 2.5 12V7ZM15.75 14.5C16.1656 14.5 16.5 14.8344 16.5 15.25C16.5 15.6656 16.1656 16 15.75 16H1.5C1.08594 16 0.75 15.6656 0.75 15.25C0.75 14.8344 1.08594 14.5 1.5 14.5H15.75Z",
    fill: "url(#paint0_linear_30807_12325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30807_12325",
    x1: 0.5,
    y1: 8,
    x2: 16.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6385FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A81FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30807_12325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.5efcd21d35a7e06cd50aee09d1c2fe53.svg";
export { ForwardRef as ReactComponent };